import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BookOpen, Calendar, ShoppingCart, Snowflake } from 'lucide-react';
export const ProductShowcase = () => {
  return <section className="bg-white px-4 py-10 md:py-20 lg:px-8" id="product" data-id="element-167">
      <div className="mx-auto max-w-6xl" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-169">
          <h2 className="mb-4 font-serif text-3xl font-bold text-text-dark md:text-5xl" data-id="element-170">
            EL PROTOCOLO DE CENAS TRANQUILAS: LAS 4 ESTACIONES
          </h2>
          <p className="mx-auto max-w-3xl text-xl text-text-dark/80" data-id="element-171">
            El plan digital completo paso a paso para crear un mes de cenas
            protegidas en solo cuatro horas.
          </p>
        </motion.div>

        <div className="grid gap-12 lg:grid-cols-2 lg:items-center" data-id="element-172">
          {/* Left: Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1" data-id="element-173">
            <img src="https://cdn.magicpatterns.com/uploads/boZK8YNxgQmJ56ZSeWZ8rb/2.png" alt="Las 4 Guías de Temporada" className="w-full rounded-2xl shadow-xl" data-id="element-174" />
          </motion.div>

          {/* Right: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 flex flex-col space-y-8 lg:order-2" data-id="element-175">
            <p className="text-lg text-text-dark" data-id="element-176">
              A diferencia de las típicas guías de "comidas congeladas" que
              terminan siendo una masa insípida y blanda, nuestro sistema de
              Escudo de Frescura por Capas asegura que cada ingrediente mantenga
              su textura original y color vibrante.
            </p>

            <div data-id="element-177">
              <h3 className="mb-6 font-serif text-2xl font-bold text-terracotta" data-id="element-178">
                Qué incluye el sistema:
              </h3>
              <ul className="space-y-4" data-id="element-179">
                <li className="flex items-start space-x-3" data-id="element-180">
                  <Snowflake className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-181" />
                  <span className="text-text-dark" data-id="element-182">
                    <strong data-id="element-183">
                      Recetas Exclusivas Optimizadas para Congelador:
                    </strong>{' '}
                    Diseñadas para nunca perder su sabor.
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-184">
                  <ShoppingCart className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-185" />
                  <span className="text-text-dark" data-id="element-186">
                    <strong data-id="element-187">Listas de Compras Completas:</strong> Entra y sal de
                    la tienda en tiempo récord.
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-188">
                  <Calendar className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-189" />
                  <span className="text-text-dark" data-id="element-190">
                    <strong data-id="element-191">Plan de Conveniencia Mensual:</strong> Organización
                    simple (incluye plantillas en blanco).
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-192">
                  <BookOpen className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-193" />
                  <span className="text-text-dark" data-id="element-194">
                    <strong data-id="element-195">Acceso de por Vida:</strong> Incluyendo todas las
                    actualizaciones futuras.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>

        {/* Bonuses Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-20 rounded-3xl bg-white p-8 shadow-xl md:p-12 border border-gray-100" data-id="element-196">
          <div className="grid gap-10 md:grid-cols-2 md:items-center" data-id="element-197">
            <div data-id="element-198">
              <h3 className="mb-6 font-serif text-2xl font-bold text-terracotta" data-id="element-199">
                BONOS INCLUIDOS:
              </h3>
              <ul className="space-y-4 text-lg" data-id="element-200">
                <li className="flex items-center space-x-3" data-id="element-201">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-terracotta" data-id="element-202">
                    1
                  </span>
                  <span className="font-medium text-text-dark" data-id="element-203">
                    Guía de Ahorro en el Presupuesto de Comida.
                  </span>
                </li>
                <li className="flex items-center space-x-3" data-id="element-204">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-terracotta" data-id="element-205">
                    2
                  </span>
                  <span className="font-medium text-text-dark" data-id="element-206">
                    Reto de Limpieza y Organización del Congelador.
                  </span>
                </li>
                <li className="flex items-center space-x-3" data-id="element-207">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-terracotta" data-id="element-208">
                    3
                  </span>
                  <span className="font-medium text-text-dark" data-id="element-209">
                    Hoja Maestra de Guarniciones Rápidas.
                  </span>
                </li>
              </ul>

              <div className="mt-8 space-y-4" data-id="element-210">
                <p className="text-xl text-gray-400 line-through decoration-red-400 decoration-2" data-id="element-211">
                  Valor Total: $148
                </p>
                <a href="#mid-pricing" onClick={e => {
                e.preventDefault();
                document.getElementById('mid-pricing')?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              }} className="group inline-flex w-full items-center justify-center rounded-full bg-terracotta px-8 py-4 text-lg font-bold text-white shadow-lg transition-all hover:bg-[#d6761b] hover:shadow-xl hover:-translate-y-0.5 md:w-auto" data-id="element-212">
                  Obtén el Paquete de las 4 Estaciones hoy por solo $9.98
                  <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-213" />
                </a>
              </div>
            </div>

            <div className="relative overflow-hidden rounded-xl shadow-lg" data-id="element-214"></div>
          </div>

          {/* Individual Bonus Images */}
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-3" data-id="element-215">
            <img src="https://cdn.magicpatterns.com/uploads/pCRByrYVXuGSjhn77NNxJy/Bono_1.png" alt="Guía de Ahorro en el Presupuesto de Comida" className="w-full rounded-xl shadow-md" data-id="element-216" />
            <img src="https://cdn.magicpatterns.com/uploads/v9VzhrANaPzeqMPY7strqg/Bono_2.png" alt="Hoja Maestra de Guarniciones Rápidas" className="w-full rounded-xl shadow-md" data-id="element-217" />
            <img src="https://cdn.magicpatterns.com/uploads/nmia2XLaB8byCj1Jyn8vyQ/Bono_3.png" alt="Reto de Limpieza y Organización del Congelador" className="w-full rounded-xl shadow-md" data-id="element-218" />
          </div>
        </motion.div>
      </div>
    </section>;
};